import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ShieldAlert, X } from "lucide-react";

/**
 * Permanent security warning shown to candidates on their dashboard.
 * Dismissible only for the current session (resets on next visit).
 */
export default function FraudAlertBanner() {
  const { t } = useTranslation();
  const [closed, setClosed] = useState(false);

  if (closed) return null;

  return (
    <div
      className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 mb-4 flex items-start gap-3"
      data-testid="fraud-alert-banner"
    >
      <ShieldAlert className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
      <div className="flex-1 text-sm leading-relaxed text-slate-800">
        <strong className="text-amber-900">⚠️ {t("fraud_alert.title")}</strong>
        <span className="block mt-0.5 text-slate-700">{t("fraud_alert.body")}</span>
        <a
          href="mailto:contact@k2mondemploiconnect.com?subject=Signalement%20de%20fraude"
          className="inline-block mt-1.5 text-[#004EEB] hover:underline font-medium"
          data-testid="fraud-alert-report-link"
        >
          {t("fraud_alert.cta")}
        </a>
      </div>
      <button
        type="button"
        onClick={() => setClosed(true)}
        className="text-slate-400 hover:text-slate-700 transition flex-shrink-0"
        aria-label="Fermer"
        data-testid="fraud-alert-close"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
